import { SVGProps } from 'react'

const MailForwardIcon = ({ fill = 'white', ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={props.width || '48'}
      height={props.height || '48'}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M4.6665 5.14285L25.4443 24.2857L45.1427 5.14285H4.6665Z' stroke={fill} strokeWidth='3.42857' strokeLinejoin='round' />
      <path d='M11.8096 43.4286H43.9465C44.6072 43.4286 45.1429 42.8929 45.1429 42.2321V5.14285' stroke={fill} strokeWidth='3.42857' strokeLinecap='round' />
      <path d='M2.28564 24.2857H16.5714' stroke={fill} strokeWidth='3.42857' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M7.04761 33.8571H23.7143' stroke={fill} strokeWidth='3.42857' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

export default MailForwardIcon
